import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "./AuthProvider";

import { LoadingScreen } from "@/shared/components/LoadingScreen";

export function RequireAuthentication() {
  const { session, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <LoadingScreen label="Checking your session…" />;
  if (!session?.isAuthenticated)
    return (
      <Navigate
        replace
        state={{
          returnTo: `${location.pathname}${location.search}${location.hash}`,
        }}
        to="/signin"
      />
    );

  return <Outlet />;
}
